import { FC, useContext } from "react";

import axios from "axios";

import { Form } from "@components/Form/Form";
import FORM_DETAILS from "@jsons/FORM_DETAILS.json";
import { FormProvider } from "@components/FormProvider/FormProvider";
import { AuthContext } from "@components/AuthProvider/contexts/Auth.context";
import { IEventRegistrationForm } from "@models/EventRegistrationForm.model";

import { Step1 } from "./components/Step1";

export const EventRegistrationFormRoute: FC = () => {
  const {
    user: { email },
    authUser: { uid },
  } = useContext(AuthContext)!;

  return (
    <FormProvider<IEventRegistrationForm>
      uid={uid}
      formName="event-registration"
      onSubmitSuccess={async () => {
        const pNotifyClient = axios.post(
          `${process.env.REACT_APP_NETLIFY_FUNCTIONS_URL}/notify-client`,
          JSON.stringify({
            uid,
          }),
        );
        const pRequestConfirmation = axios.post(
          `${process.env.REACT_APP_NETLIFY_FUNCTIONS_URL}/request-confirmation`,
          JSON.stringify({
            email,
            eventId: uid,
          }),
        );

        await Promise.all([pNotifyClient, pRequestConfirmation]);
      }}
    >
      {({
        draft,
        isSaving,
        isSubmitted,
        isSavePending,
        onSubmit,
        onSaveChanges,
      }) => (
        <Form
          totalSteps={1}
          currentStep={1}
          isSaving={isSaving}
          title={FORM_DETAILS.EventRegistration.title}
          description={FORM_DETAILS.EventRegistration.description}
        >
          <Step1
            draft={draft}
            isSubmitted={isSubmitted}
            isSavePending={isSavePending}
            onSubmit={onSubmit}
            onChange={onSaveChanges}
          />
        </Form>
      )}
    </FormProvider>
  );
};
